import React from 'react';
import styled from 'styled-components';

const StyledGameInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 20px;
  padding: 20px;
  border: 2px solid #333;
  background: #111;
  color: #fff;
  min-width: 160px;
  
  div {
    margin-bottom: 20px;
  }
  
  h2 {
    font-size: 1.2rem;
    margin-bottom: 10px;
    text-align: center;
  }
  
  p {
    font-size: 1.5rem;
    text-align: center;
    margin: 0;
  }
`;

const GameInfo = ({ score, level, lines, isGameOver }) => {
  return (
    <StyledGameInfo>
      <div>
        <h2>分数</h2>
        <p>{score}</p>
      </div>
      <div>
        <h2>等级</h2>
        <p>{level}</p>
      </div>
      <div>
        <h2>行数</h2>
        <p>{lines}</p>
      </div>
      {isGameOver && (
        <div style={{ color: 'red' }}>
          <h2>游戏结束</h2>
          <p>再试一次!</p>
        </div>
      )}
    </StyledGameInfo>
  );
};

export default GameInfo;